import './GenericErrorFallback.scss';

const GenericErrorFallback = ({ children }) => {
  return <div className="rounded-container error-wrapper">{children}</div>;
};

export default GenericErrorFallback;
